const defaultTexts = {
  login: 'Login',
  products: 'Products',
  features: 'Features',
  prices: 'Prices',
  contact: 'Contact',
  homeBannerTopText: 'Your Gateway to Scalable<br />OpenStack Cloud Solution',
  signUp: 'Sign Up',
  openStackAdminUi: 'OpenStack Admin UI',
  openStackAdminUiText: 'Effortlessly manage your OpenStack Cloud infrastructure with the OpenStack Admin UI.<br /><br />From user management to service configurations and resource quotas, this powerful interface gives administrators complete control over every aspect of your cloud environment.',
  openStackCustomerUi: 'OpenStack Customer UI',
  openStackCustomerUiText: 'Empower your users with the OpenStack Customer UI, providing seamless access to cloud services, infrastructure, and resources.<br /><br />Whether it\'s provisioning new instances or managing existing ones, this intuitive interface ensures a smooth and efficient experience for your customers.',
  openStackBilling: 'OpenStack Billing System',
  openStackBillingText: 'Take charge of your OpenStack Cloud\'s billing and pricing with the OpenStack Billing System.<br /><br />Designed for flexibility and precision, it allows you to manage all billing processes through an easy-to-use web interface, ensuring transparency and accuracy for both administrators and customers.',
  customizableUserInterfaces: 'Customizable User Interfaces',
  customizableUserInterfacesText1: 'Tailor the OpenStack Admin and Customer UIs to reflect your brand identity. Easily customize the interfaces with your company logo and select primary and secondary colors that align with your brand.',
  customizableUserInterfacesText2: 'The start page of the Customer UI can also be personalized with unique design elements and promo text, creating a welcoming experience for your users. ',
  customizableUserInterfacesText3: 'Additionally, configure the user registration process with different forms to suit your specific requirements.',
  flexibleAndSecureBillingSystem: 'Flexible and Secure Billing System',
  flexibleAndSecureBillingSystemText1: 'The Openstack Stack Billing System offers comprehensive account management, allowing you to configure user accounts as prepaid or postpaid, automate or manually provision invoices, and set pricing per OpenStack region.',
  flexibleAndSecureBillingSystemText2: 'Our system is built with security and trust in mind—credentials used for data fetching are restricted to only the necessary OpenStack API endpoints required for billing, ensuring your data remains protected and your operations secure.',
  services: 'Services',
  contactPhoneText: 'Tel: +995 32 2250590',
  contactEmailText: 'E-mail: info@flexostack.io',
  grena1999: 'GRENA 1999 - ',
  allRightsReserved: 'All Rights Reserved',
  email: 'E-mail',
  password: 'Password',
  forgotPassword: 'Forgot Password',
  authorizationFailedText: 'Authorization failed! Try again.',
  userInfo: 'User Info',
  loginEmail: 'Login E-mail',
  confirmPassword: 'Confirm Password',
  firstName: 'First Name',
  lastName: 'Last Name',
  accountInfo: 'Account Info',
  accountType: 'Account Type',
  companyName: 'Company Name',
  companyId: 'Company ID',
  address: 'Address',
  contactPhone: 'Contact Phone',
  contactEmail: 'Contact E-mail',
  country: 'Country',
  submit: 'Submit',
  pleaseFillOut: 'Please fill out',
  invalidEmail: 'Invalid E-mail',
  passwordRequirements: 'Password must be at least 8 characters long and contain uppercase letters, lowercase letters, numbers and special symbols',
  passwordDoesNotMatch: 'Password does not match',
  subscriptions: 'Subscriptions',
  users: 'Users',
  balance: 'Balance',
  notifications: 'Notifications',
  account: 'Account',
  openStackSolutionKit: 'OpenStack Solution Kit',
  selectSolutionText: 'Select desired product',
  selectSubscriptionText: 'Select subscription which fits your requirements',
  configureParametersText: 'Configure required parameters',
  payAndSubmit: 'Pay & Submit',
  openStackSolutionKitDescription: 'Effortlessly manage your OpenStack Cloud infrastructure with the OpenStack Admin UI.<br /><br />Empower your users with the OpenStack Customer UI, providing seamless access to cloud services, infrastructure, and resources.<br /><br />Take charge of your OpenStack Cloud\'s billing and pricing with the OpensStack Billing System.',
  next: 'Next',
  openStackServices: 'OpenStack Services',
  userInterfaces: 'User Interfaces',
  billingService: 'Billing Service',
  optionalServices: 'Optional Services',
  serviceDomain: 'Service Domain',
  apiVersion: 'API Version',
  isIdentityProvider: 'Is Identity Provider',
  defaultRegion: 'Default Region',
  regionName: 'Region Name',
  appCredentialId: 'App Credential ID',
  appCredentialSecret: 'App Credential Secret',
  visibleToOpenStackCustomerUi: 'Visible to OpenStack Customer UI',
  addSubscriptionResponsePlaceholder: 'Response from OpenStack API will be displayed here.',
  checkAccess: 'Check Access',
  serviceDomainHelperText: 'Service domain is an address by which openstack service api is publicly available.<br /><br />Please provide this address in following format: “https://service-domain:port-number”',
  isIdentityProviderHelperText: 'Identity Provider is OpenStack Identity service, which is used to manage users, projects and authentication.',
  appCredentialIdHelperText: 'If you want your customers to register through OpenStack Customer UI, it is required to provide App Credential ID and Secret, which are confiured in OpenStack with Admin role and has permission to create new user. ',
  visibleToOpenStackCustomerUiHelperText: 'If you want to allow your customers to use this service in OpenStack Customer UI, you should check this option.',
  userInterfaceDomain: 'User Interface Domain',
  googleRecaptchaConfiguration: 'Google reCaptcha Configuration',
  siteKey: 'Site Key',
  secretKey: 'Secret Key',
  customizeYourInterfaceAppearance: 'Customize your interface appearance',
  logo: 'Logo',
  uploadLogosFile: 'Upload Logo\'s File',
  primaryColor: 'Primary Color',
  secondaryColor: 'Secondary Color',
  edit: 'Edit',
  save: 'Save',
  userInterfaceAdminDomainHelperText: 'Provide domain or subdomain name address, by which OpenStack Admin UI will be accessible to your Cloud Admin users. Only users with “Admin” role can access this interface.<br /><br />You may provide several addresses, if desired. These domains must be a valid, registered domain name and you must be owner of it.<br /><br />Also, you have to add DNS records, for provided domains/subdomains to your NS servers.<br /><br />You can see required DNS records on the right side of the form.<br /><br />If given records are not added to NS Servers, the form submission will fail.',
  userInterfaceCustomerDomainHelperText: 'Provide domain or subdomain name address, by which OpenStack Customer UI will be accessible to your Cloud Customer users. Only users with “Admin” role can access this interface.<br /><br />You may provide several addresses, if desired. These domains must be a valid, registered domain name and you must be owner of it.<br /><br />Also, you have to add DNS records, for provided domains/subdomains to your NS servers.<br /><br />You can see required DNS records on the right side of the form.<br /><br />If given records are not added to NS Servers, the form submission will fail.',
  googleRecaptchaConfigurationHelperText: 'Please, provide Google reCaptcha configuration below.<br /><br />You have to allow access to Google reCaptcha API from domain name provided above.',
  apply: 'Apply',
  loginConfiguration: 'Login Configuration',
  defaultOpenStackDomain: 'Default OpenStack Domain',
  defaultOpenStackUserRole: 'Default OpenStack User Role',
  registrationFormFields: 'Registration Form Fields',
  priority: 'Priority',
  text: 'Text',
  file: 'File',
  termsOfUse: 'Terms of Use',
  required: 'Required',
  privacyPolicy: 'Privacy Policy',
  uploadFile: 'Upload file',
  fileUrl: 'File URL',
  customFields: 'Custom Fields',
  fieldKey: 'Field Key',
  label: 'Label',
  customerUserInterfaceDomainHelperText: 'Provide domain name address, by which OpenStack Customer UI will be accessible to your Cloud Customers.<br /><br />This domain name must be a valid, registered domain name and you must be owner of it.',
  defaultOpenStackDomainHelperText: 'Default OpenStack Domain will be used when cloud customer will log in to OpenStack Customer UI. User must belong to this domain, otherwise authentication will fail.',
  defaultOpenStackUserRoleHelperText: 'If OpenStack Customer UI will be configured to register new customer, Default OpenStack Role will be used to assign ne users to.',
  username: 'Username',
  customizeStartPage: 'Customize Start Page',
  backgroundType: 'Background Type',
  colorType: 'Color Type',
  backgroundColor: 'Background Color',
  gradientColor: 'Gradient Color',
  uploadBackgroundImage: 'Upload Background Image',
  backgroundImage: 'Background Image',
  headingText: 'Heading Text',
  promoText: 'Promo Text',
  customizeContactInfo: 'Customize Contact Info',
  company: 'Company',
  color: 'Color',
  image: 'Image',
  solid: 'Solid',
  gradient: 'Gradient',
  phone: 'Phone',
  generalConfiguration: 'General Configuration',
  enableBillingService: 'Enable Billing Service',
  defaultAccountType: 'Default Account Type',
  prepaid: 'Prepaid',
  postpaid: 'Postpaid',
  postpaidInvoiceType: 'Postpaid Invoice Type',
  auto: 'Auto',
  manual: 'Manual',
  postpaidInvoicePayPeriod: 'Postpaid Invoice Pay Period',
  allowPublicPriceCalculator: 'Allow Public Price Calculator',
  currency: 'Currency',
  enableVatTax: 'Enable VAT Tax',
  pricesIncludeVatTax: 'Prices include VAT Tax',
  vatTaxPerc: 'VAT Tax %',
  defaultAccountTypeHelperText: 'When new user is registered to OpenStack cloud, the default billing account type will be applied to this user. May be prepaid or postpaid. If prepaid type is used, user must refill his/her balance before start using cloud resources. If postpaid type is selected, user will be able to start using cloud resources and pay at the beginning of next month.<br /><br />Billing type can be managed individually per account as well in billing accounts section.',
  postpaidInvoiceTypeHelperText: 'For postpaid billing accounts invoice cn be generated automatically by billing system or you can create it manually.<br /><br />If automatic method is used, billing system tracks the invoice status and it\'s due date. If invoice status does not change to paid before due date passed, it will start suspend process and apply suspend policy to all OpenStack resources.<br /><br />Suspend policy is managed per OpenStack service below.<br /><br />If manual method is selected, you have to provide invoices to users yourself outside of billing system.<br /><br />No tracking os such invoices are carried by billing system.',
  postpaidInvoicePayPeriodHelperText: 'If postpaid invoice is generated by billing system, postpaid invoice pay period instructs billing system on how many days should be given to the user to cover the costs in the invoice.<br /><br />This period determines due date of automatically generated invoices.',
  allowPublicPriceCalculatorHelperText: 'If public price calculator is allowed, it will be visible to all users (including unauthorized) on start page of OpenStack Customer UI.',
  paymentMethods: 'Payment Methods',
  paymentMehotdsSupportingSelectedCurrency: 'Payment methods supporting selected currency',
  payWith: 'Pay with',
  paypalClientId: 'PayPal Client ID',
  selectPaymentMethodAndSubmit: 'Select payment method and submit',
  payFromBalance: 'Pay from balance',
  subscribeWith: 'Subscribe with',
  emptyBalanceNotificationText: 'There is no enough funds on your balance! Please, click on Balance button in top navigation bar, enter the amount which you want to transfer to your FlexoStack account balance, select prefered payment method and follow the instructions for given payment method to complete transaction.',
  amount: 'Amount',
  creditCard: 'Credit Card',
  subscribeWithPaypalHelperText: 'By clicking on PayPal subscribe button, your monthly subscription starts automatically, and will be renew each month.<br /><br />You may cancel your PayPal subscription at any time, but we aware that this will end your OpenStack Solution Kit subscription as well, when the subscription period is over.',
  anErrorOccured: 'An error occured!',
  emailAlreadyExists: 'User with ###EMAIL### e-mail already exists',
  signUpSuccessfullText: 'You have successfully registered<br />E-mail validation link has been sent to your e-mail',
  resendValidationEmail: 'Resend validation e-mail',
  send: 'Send',
  pleaseFillOutEmail: 'Please fill out e-mail',
  resendValidationEmailSuccessfullText: 'E-mail validation link has been sent to your e-mail',
  userNotExists: 'User does not exist or is blocked',
  userAlreadyActive: 'User is already active',
  userNotFound: 'User not found',
  yourAccountIsActivated: 'Your account is activated',
  resetPassword: 'Reset Password',
  resetPasswordSuccessfullText: 'Password reset link has been sent to your e-mail',
  yourPasswordHasChanged: 'Your password has changed',
  keepResourcesUntouched: 'Keep resources untouched',
  suspendInstances: 'Suspend instances',
  shelveOffloadInstances: 'Shelve offload instances',
  deleteAllPaidResources: 'Delete all paid resources',
  suspendAction: 'Suspend Action',
  suspendDelayMinutes: 'Suspend Delay (Minutes)',
  finalAction: 'Final Action',
  finalActionDelayMinutes: 'Final Action Delay (Minutes)',
  suspendActionHelperText: 'Suspend action instructs billing system on action, which should be taken when user’s balance runs out of money or postpaid invoice due date has passed and invoice is still unpaid.<br /><br />The action depends on OpenStack service. F.e. Compute (Nova) instances can be suspended, or shelved. In most other services this action can be “Keep” or “Delete”.<br /><br />The suspend action will be taken after suspend delay. If you would like to carry this action immediately, configure suspend delay to 0.',
  finalActionHelperText: 'Final action instructs billing system on action, which should be taken when user’s balance runs out of money or postpaid invoice due date has passed and invoice is still unpaid and suspend action has already taken.<br /><br />The action depends on OpenStack service. F.e. Compute (Nova) instances can be suspended, or shelved. In most other services this action can be “Keep” or “Delete”.<br /><br />The final action will be taken after final action delay. If you would like to carry this action immediately, configure final action delay to 0.<br /><br />“Keep” action will remain OpenStack resources untouched',
  back: 'Back',
  formValidationError: 'Form validation error',
  formValidationErrorText: 'Please, fill out the following fields:',
  identityProviderIsNotSelected: 'Identity Provider is not selected',
  accessDenied: 'Access denied',
  duplicatedRegionName: 'Duplicated region name',
  permissions: 'Permissions',
  allowBillingManagementText: 'Allow Billing Service Management in OpenStack Admin UI',
  displayBillingServiceConfiguration: 'Display Billing Service Configuration',
  displayBillingServiceAnalytics: 'Display Billing Service Analytics',
  displayUserAccounts: 'Display User Accounts',
  updateUserAccounts: 'Update User Accounts',
  displayOpenStackServiceConfiguration: 'Display OpenStack Service Configuration',
  addNewOpenStackServiceToBilling: 'Add New OpenStack Service to Billing',
  updateOpenStackServiceConfiguration: 'Update OpenStack Service Configuration',
  deleteOpenStackServiceFromBilling: 'Delete OpenStack Service from Billing',
  displayPrices: 'Display Prices',
  updatePrices: 'Update Prices',
  addNewPrices: 'Add New Prices',
  adminUiDomain: 'Admin UI Domain',
  customerUiDomain: 'Customer UI Domain',
  verified: 'Verified',
  notVerified: 'Not verified',
  subdomainPrefixOptional: 'Subdomain Prefix (Optional)',
  domainName: 'Domain Name',
  verify: 'Verify',
  rsaCertificateForAdminUiDomain: 'RSA Certificate for Admin UI Domain',
  rsaCertificateForCustomerUiDomain: 'RSA Certificate for Customer UI Domain',
  upload: 'Upload',
  generate: 'Generate',
  copyYourCertificateHere: 'Copy your certificate here',
  copyYourPrivateKeyHere: 'Copy your private key here',
  copyYourFullChainHere: 'Copy your certification authority chain here',
  rsaCertificateForDomainHelperText: 'If you choose to generate RSA certificate, we will automatically generate Let\'s encrypt certificate for each of provided domain/subdomain and we will maintain autorenew of this certificate.<br /><br />If you choose upload the certificate, you have to provide valid certificate, it\'s private key and certification authority chain.<br /><br />You may provide only one certificate for all provided domains/subdomains, if certificate includes all of them, or you may upload several certificates for different domains/subdomains, but be aware that all provided domains/subdomains must be included in any provided certificates.',
  type: 'Type',
  name: 'Name',
  value: 'Value',
  domainVerifyHelperText: 'Required DNS A record for domain name or DNS CNAME record for desired subdomain will be displayed here. This record must be added to your NS servers, before you submit this form. Otherwise, the automatic check will fail.',
  latestNotifications: 'Latest Notifications',
  configuration: 'Configuration',
  accounting: 'Accounting',
  accounts: 'Accounts',
  billing: 'Billing',
  invoices: 'Invoices',
  payments: 'Payments',
  noValidCertificateForDomain: 'No valid certificate for domain',
  showAllRegions: 'Show All Regions',
  domain: 'Domain',
  credentialsProvided: 'Credentials Provided',
  visibleToUis: 'Visible to UIs',
  onlyOneIdentityProviderText: 'Only one Identity Provider is supported for all regions',
  notConfigured: 'Not Configured',
  renewable: 'Renewable',
  payment: 'Payment',
  paymentSuccessfullText: 'Your payment is accepted and processing... You can submit the form',
  paymentFailedText: 'Payment failed!',
  subscription: 'Subscription',
  productsAndService: 'Products & Service',
  status: 'Status',
  subscribedAt: 'Subscribed at',
  days: 'Days',
  left: 'Left',
  default: 'Default',
  yes: 'Yes',
  no: 'No',
  add: 'Add',
  service: 'Service',
  serviceInThisRegionAlreadyExists: 'Service in this region already exists',
  deleteRegion: 'Delete Region',
  deleteRegionText: 'Are you sure you want to delete all services in ###REGION###?',
  delete: 'Delete',
  noLogo: 'No Logo',
  adminUiLogo: 'Admin UI Logo',
  customerUiLogo: 'Customer UI Logo',
  enabled: 'Enabled',
  disbaled: 'Disabled',
  current: 'Current',
  subscribe: 'Subscribe',
  cancel: 'Cancel',
  update: 'Update',
  activeSubscriptions: 'Active Subscriptions',
  autorenew: 'Autorenew',
  renewDate: 'Renew Date',
  paymentMethod: 'Payment method',
  cancelSubscription: 'Cancel Subscription',
  cancelSubscriptionText: 'Are you sure you want to cancel your subscription?',
  updateSubscription: 'Update Subscription',
  updateSubscriptionText: 'Are you sure you want to update your subscription?',
  confirm: 'Confirm',
  refillYourBalance: 'Refill Your Balance',
  refillBalanceSuccessfullText: 'Your payment is accepted and processing',
  noEnoghFunds: 'No enough funds!',
  sslCertificate: 'SSL Certificate',
  expirationDate: 'Expiration Date',
  autoRenew: 'Auto Renew',
  profile: 'Profile',
  roles: 'Roles',
  changePassword: 'Change Password',
  accountId: 'Account ID',
  createdAt: 'Created At',
  active: 'Active',
  disabled: 'Disabled',
  passwordChangedText: 'Your password has been changed successfully',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  incorrectOldPassword: 'Incorrect old password',
  addNewUser: 'Add New User',
  editUser: 'Edit User',
  deleteUser: 'Delete User',
  enable: 'Enable',
  disable: 'Disable',
  optional: 'optional',
  userRole: 'User Role',
  deleteUserText: 'Are you sure you want to delete ###USER### user?',
  accountNotifications: 'Account Notifications',
  emailNotificationsSettings: 'Email Notifications Settings',
  addEmail: 'Add E-mail',
  notificationTypes: 'Notification Types',
  notificationTypesError: 'Please check at least one type',
  docs: 'Docs',
  documentation: 'Documentation',
  openStackConfigurationDocs: 'OpenStack Configuration Docs',
  openStackBillingServiceDocs: 'OpenStack Billing Service Docs',
  openStackBackupAutomationDocs: 'OpenStack Backup Automation Docs',
  noNotifications: 'No notifications',
  newNotification: 'New Notification',
  notificationHasBeenSent: 'Notification has been sent',
  notificationType: 'Notifications Type',
  cookiesPopupText: 'The cookies we use on our website have different tasks targeting ideal user experience. Session cookies ensure that the website can be visited and its features can be utilized. Performance cookies analyze the browsing habits of users and improves the performance of the website. Functional cookies identify the selections of the users on the website and facilitate their browsing experience. Marketing cookies notify suitable campaigns using promotion and social media information.',
  readOurCookiesPolicy: 'Read our cookies policy.',
  cookiesAcceptLabel: 'Accept',
  cookiesRejectLabel: 'Reject',
  noActiveSubscriptions: 'No Active Subscriptions',
  price: 'Price',
  noDocs: 'No Docs',
  signUpEnabled: 'Sign Up Enabled',
  signUpDisabled: 'Sign Up Disabled',
  accountSettings: 'Account Settings',
  registeredExternalApplications: 'Registered External Applications',
  registerNewApplication: 'Register New Application',
  updateApplication: 'Update Application',
  deleteApplication: 'Delete Application',
  applicationName: 'Application Name',
  applicationNameRequirements: 'Application name must be alphanumeric',
  applicationAlreadyExists: 'This application already exists',
  clientId: 'Client ID',
  clientSecret: 'Client Secret',
  copy: 'Copy',
  regenerate: 'Regenerate',
  deleteApplicationText: 'Are you sure you want to delete application ###APPNAME###?',
  regenerateApplicationSecretText: 'Are you sure you want to generate new client secret for application ###APPNAME###?',
  secretCopiedToClipboardText: 'Client secret has been copied to clipboard',
  stripeSecretKey: 'Stripe Secret Key',
  iSender: 'iSender',
  buyNewSubscription: 'Buy New Subscription',
  buyNewSubscriptionText: 'Are you sure you want to buy new subscription?',
  useISender: 'Use iSender for invoice management',
  useISenderHelperText: 'Use iSender service for invoice management',
  openStackSolutionKitProductDescription: 'Manage your entire OpenStack Cloud Infrastructure with ease through our modern, unified Admin Interface. Configure billing, set pricing rules, and monitor accounting — all from one intuitive dashboard. You can fully customize the interface to match your company’s branding and style. No installation or maintenance is required — FlexoStack is 100% SaaS-based, so you can start managing your cloud instantly.<br /><br />Our dedicated Customer Interface, included in the OpenStack Solution Kit, lets you offer cloud services directly to your customers. It’s a simple, user-friendly web application that makes managing cloud resources effortless and accessible from anywhere.<br /><br />The FlexoStack Billing Engine gives you complete control over how your OpenStack services are billed. Define which resources are chargeable, set custom pricing models, and easily integrate popular payment gateways like PayPal and Stripe to collect payments securely from your customers.',
  iSenderApplication: 'iSender Application',
  iSenderApplicationProductDescription: 'iSender is an intelligent communication platform that helps you automate the delivery of invoices, alerts, and other business notifications. Whether it’s billing reminders, service updates, or custom announcements — iSender ensures your messages reach customers on time, every time.<br /><br />Create and manage beautiful, ready-to-use templates for email notifications. Each template can be customized with your branding and dynamic content, ensuring a consistent professional look across all customer communications. iSender can also be embedded into any other application using a simple HTML &lt;iframe&gt;, allowing seamless integration into your existing portals or dashboards. With support for both manual and automated sending, iSender adapts to your workflow.<br /><br />Schedule your messages for specific dates, times, or recurring periods and let iSender handle the rest. Send through email with seamless integration to your existing systems. From automated invoicing to personalized customer engagement, iSender gives you complete control and reliability in one powerful tool.',
  learnMore: 'Learn More',
  iSenderInvoicingLabel: 'Automate Your Invoicing and Notifications',
  iSenderDesignLabel: 'Design and Personalize Templates with Ease',
  iSenderWebLabel: 'Embed iSender into Your Web Application',
  iSenderInvoicingText: 'With iSender, you can effortlessly schedule and send invoices, payment reminders, and notifications via Email. Our smart scheduling engine ensures every message reaches your clients at the right time, helping you maintain professional consistency while saving hours of manual work.<br /><br />Whether it’s a single invoice or a recurring notification campaign, iSender handles it automatically. You define the timing and recipient lists once, or feed recipients list when needed, and the system takes care of the rest.',
  iSenderDesignText: 'Create stunning, data-driven invoice and notification templates using iSender’s built-in Template Builder. Customize every detail—from your logo and branding to dynamic content fields that pull data directly from provided data feed. Each message feels personalized, yet automated.<br /><br />The Template Builder empowers your team to create professional, consistent communication without writing a single line of code. Save, reuse, or modify templates anytime and instantly apply changes across all scheduled messages. It’s a simple way to maintain brand identity while increasing operational efficiency.',
  iSenderWebText: 'iSender is built to integrate seamlessly into any modern web application, giving your users access to automated invoicing and notification tools without ever leaving your platform. The embeddable widget can be placed directly inside your web interface, allowing smooth interaction and consistent user experience—all powered by iSender’s robust backend.<br /><br />Authorization is handled securely using predefined client application credentials, ensuring that only verified systems can access the embedded features. This setup eliminates complex authentication flows while maintaining enterprise-grade security. With just a few configuration steps, you can bring the full functionality of iSender into your web app—ready to send, schedule, and manage communications instantly.',
}

export default defaultTexts